import { useBoolean } from "@chakra-ui/react";
import { WatchlistButton } from "src/components/common/buttons/watchlist-button/watchlist-button";

interface IWatchlistButtonWrapper {
    wikifolioId: string;
    wikifolioShortDescription: string;
    isOnWatchlist: boolean;
}
export const WatchlistButtonWrapper = ({ wikifolioId, wikifolioShortDescription, isOnWatchlist: isInitialOnWatchlist }: IWatchlistButtonWrapper) => {
    const [isOnWatchlist, setIsOnWatchlist] = useBoolean(isInitialOnWatchlist);

    return (
        <WatchlistButton
            titleBoxProps={{ display: ["none", "initial"] }}
            variant={["unstyled", "outline"]}
            size="sm"
            sx={{
                span: { mr: 0 },
                display: ["flex!important", null],
            }}
            gap={1}
            wikifolioId={wikifolioId}
            wikifolioShortDescription={wikifolioShortDescription}
            isOnWatchlist={isOnWatchlist}
            setOnWatchlist={setIsOnWatchlist.toggle}
        />
    );
};
